var template = $('#warranty-product-template').detach();
template.attr('id', null);

$('.form__input-wrapper--labelled input').each(function () {
	$(this).toggleClass('is-filled', $(this).val() != '');
});

var productLookup = [];
var categories = [];
$('#warranty-product-type').change(filterProducts);
$.getJSON("/products.json", function (data) {
	for (var i = 0; i < data.products.length; i++) {
		var product = data.products[i];
		if (product.product_type != '' && product.product_type != 'candyrack_generated') {
			if (!categories.includes(product.product_type)) {
				categories.push(product.product_type);
			}
		}
		for (var j = 0; j < product.variants.length; j++) {
			var newProduct = JSON.parse(JSON.stringify(product));
			delete newProduct.variants;
			newProduct.sku = product.variants[j].sku;
			if (newProduct.sku != '') {
				productLookup.push(newProduct);
			}
		}
	}

	for (var i = 0; i < categories.length; i++) {
		var o = new Option(categories[i], categories[i]);
		$(o).html(categories[i]);
		$('#warranty-product-type').append(o);
	}

	for (var i = 0; i < productLookup.length; i++) {
		var item = template.clone();
		productLookup[i].item = item;

		item.attr('data-sku', productLookup[i].sku);

		$('.warranty-product-results').append(item);
		item.find('.warranty-product-title').text(productLookup[i].title);
		item.find('.sku').text(productLookup[i].sku);
		item.click(function () {
			var itm = $(this);
			var sku = itm.attr('data-sku');
			$('#product_sku').val(sku);
			$('#product_sku').addClass('is-filled');
			filterProducts();
			$('.warranty-product-results').hide();
		});
		if (productLookup[i].images.length > 0) {
			item.find('img').attr('src', productLookup[i].images[0].src)
			item.find('img').show();
		} else {
			item.find('img').hide();
		}
	}
});

function filterProducts() {
	var category = $('#warranty-product-type').val();
	var search = $('#product_sku').val().trim().toLowerCase();
	if (search == '' && category == '') {
		$('.warranty-product').show();
		$('.warranty-product-none').hide();
		return;
	}
	$('.warranty-product').hide()

	var cnt = 0;
	for (var i = 0; i < productLookup.length; i++) {
		if (category != '' && productLookup[i].product_type != category) continue;
		var title = productLookup[i].title.toLowerCase();
		if (title.indexOf(search) > -1) {
			productLookup[i].item.show();
			cnt++;
			continue;
		}
		var sku = productLookup[i].sku.toLowerCase();
		if (sku.indexOf(search) > -1) {
			productLookup[i].item.show();
			cnt++;
			continue;
		}
	}

	$('.warranty-product-none').toggle(cnt == 0);

}

$('#product_sku').on('input', filterProducts);

$('.warranty-product-section').on('focusin', function () {
	$('.warranty-product-results').show();
});
$('#product_sku').on('blur', function () {
	setTimeout(function () {
		$('.warranty-product-results').hide();
	}, 500);
});

$('.warranty-product-section').click(function (event) {
	event.stopPropagation();
});

$(window).click(function () {
	$('.warranty-product-results').hide();
});

var fields1 = {
	'order_id': true,
	'product_sku': true
}
var fields2 = {
	'first_name': true,
	'last_name': true,
	'email': true,
	'phone': true,
	'company': false,
	'street1': true,
	'street2': false,
	'city': true,
	'zip': true
}

var allFields = {};
for (var key in fields1) allFields[key] = fields1[key];
for (var key in fields2) allFields[key] = fields2[key];

for (var key in allFields) {
	var field = $('#' + key);
	field.on('input', function () {
		var fld = $(this);
		var val = fld.val().trim();
		if (val != '') {
			fld.removeClass('warranty-error');
		}
	});
}

var data = {};

$('#warranty-register').click(function () {
	if ($('#fieldset').attr('disabled') == 'disabled') {
		return;
	}
	$('.warranty-error').removeClass('warranty-error');
	var errors = 0;
	for (var key in fields2) {
		var field = $('#' + key);
		var required = fields2[key];
		var name = field.next().text();
		var val = field.val().trim();
		data[key] = val;
		if (required && val == '') {
			field.addClass('warranty-error');
			errors++;
		}

		if (key == 'email' && !validateEmail(val)) {
			field.addClass('warranty-error');
			errors++;
		}
	}


	if (errors > 0) return;

	$('.please-wait').show();
	$('#fieldset').attr('disabled', 'disabled');

	data['user_id'] = '{{customer.id}}';

	$.ajax({
		url: "https://warranty.poolpartstogo.com/submit.php",
		type: "POST",
		data: data,
		success: function (data, textStatus, jqXHR) {
			success();
			$('.please-wait').hide();
			$('#fieldset').attr('disabled', null);
		},
		error: function (jqXHR, textStatus, errorThrown) {
			alert("An error occured.");
			$('.please-wait').hide();
			$('#fieldset').attr('disabled', null);
		}
	});
});

function success() {
	$('.warranty-form').hide();
	$('#warranty-success').show();
	$('.page-content').hide();
	$($('.progressbar').children()[2]).addClass('checked');
	$($('.progressbar').children()[4]).addClass('active');
	$($('.progressbar').children()[4]).addClass('checked');
}

function validateEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

$('#btn-next').click(function () {
	var errors = 0;
	for (var key in fields1) {
		var field = $('#' + key);
		var required = fields1[key];
		var name = field.next().text();
		var val = field.val().trim();
		data[key] = val;
		if (required && val == '') {
			field.addClass('warranty-error');
			errors++;
		}

		if (key == 'email' && !validateEmail(val)) {
			field.addClass('warranty-error');
			errors++;
		}
	}
	if (errors > 0) return;
	$('#page1').hide();
	$('#page2').show();

	$($('.progressbar').children()[0]).addClass('checked');
	$($('.progressbar').children()[2]).addClass('active');
});